module.exports = __webpack_public_path__ + "img/mb_hm_block02_en.4bb07748.jpg";